"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("styled-components").css`
    box-shadow: ${({theme:e})=>e.shadows.high};
    background: ${({theme:e})=>e.colors.common.light};
    padding: 0 ${({theme:e})=>e.spacing.large};
    max-width: ${({theme:e})=>e.widths.small};
    margin: auto;

    .ContactForm-header {
        border-bottom: solid 1px ${({theme:e})=>e.colors.grey[300]};
        padding: ${({theme:e})=>e.spacing.medium};
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        svg {
            color: ${({theme:e})=>e.colors.common.dark};
            margin-right: 13px;
        }

        h2 {
            margin: 0;
        }
    }

    fieldset {
        padding: 0 ${({theme:e})=>e.spacing.large};
        border: 0;

        .row {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            margin-top: ${({theme:e})=>e.spacing.large};

            .DXTextInput {
                width: 45%;

                .DXTextInput-label {
                    color: ${({theme:e})=>e.colors.grey[800]};
                    left: 0;
                }

                .DXTextInput-input {
                    border-bottom: solid 2px ${({theme:e})=>e.colors.grey[400]};
                    width: 100%;
                }
            }

            &:nth-of-type(2) {
                .DXTextInput {
                    width: 100%;
                    .DXTextInput-input {
                        width: 100%;
                    }
                }
            }

            &:nth-of-type(3) {
                .DXTextInput {
                    width: 100%;
                }
            }

            .DXTextInput-textarea {
                width: 100%;
                border-bottom: solid 2px ${({theme:e})=>e.colors.grey[400]};
            }
        }

        .text_opt_in {
            .DXCheckbox {
                .DXCheckbox-label {
                    align-items: flex-start;

                    .DXCheckbox-icon {
                        min-height: 10px;
                        min-width: 10px;
                        border: 1.5px solid
                            ${({theme:e})=>e.colors.grey[500]};
                        border-radius: 2px;
                    }

                    .DXTypography {
                        font-size: 10px;
                        font-weight: 500;
                        line-height: 11px;
                        color: ${({theme:e})=>e.colors.grey[700]};
                        margin-top: 0;
                        text-align: justify;
                    }
                }
                .DXCheckbox-input {
                    visibility: visible;
                }
            }
        }

        .DXButton {
            margin: ${({theme:e})=>e.spacing.xlarge} 0;
        }

        &:disabled {
            opacity: 0.5;
        }
    }

    .thank_you {
        text-align: center;
        padding: 37px ${({theme:e})=>e.spacing.large};

        picture {
            display: block;
            width: 100%;
            height: 0;
            padding-top: 54%;
            background: rgba(0, 0, 0, 0.2);
            margin-bottom: 50px;
        }

        @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
            padding: 61px 104px 90px;
        }

        .button {
            width: 100%;
            margin-top: 83px;
            padding: 25px;
        }
    }
`;exports.default=e,exports.styles=e;
//# sourceMappingURL=styles.js.map
